
import Vue from 'vue'
import UserProvisioning from '@/mixins/userProvisioning';
export default Vue.extend({
    mixins:[UserProvisioning],
    props:["selectedOperationUnitName","readonlymode","fundingtranche","budgetyear","projectId","sequenceId","operationUnitId","readOnlyView"],
    data(){
        return {
            uap:"",
            sapCostObject:"",
            title:"",
            objective:"",
            scopeOfWork:"",
            descriptionOfWork:"",
            contractAndWorkOrders:""
        }
    },
    watch:{
        operationUnitId:{
            immediate:true,
            handler(){
                let workScope = this.$store.getters["projectModule/getWorkScope"]({operationUnitId:this.operationUnitId,projectId:this.projectId,sequenceId:this.sequenceId})
                if(workScope){
                    this.uap = workScope.uapCode
                    this.sapCostObject = workScope.sapCostObject
                    this.title = workScope.title
                    this.objective = workScope.objective
                    this.contractAndWorkOrders = workScope.contracts
                    this.descriptionOfWork = workScope.detailedDescriptionWork
                    this.scopeOfWork = workScope.plannedWorkScope
                }else{
                    this.uap = ""
                    this.sapCostObject = ""
                    this.title = ""
                    this.objective = ""
                    this.contractAndWorkOrders = ""
                    this.descriptionOfWork = ""
                    this.scopeOfWork = ""
                }
            }
        }
    },
    methods:{
        onTitleChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,title:newVal })
        },
        onObjectiveChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,objective:newVal })
        },
        onPlannedScopeChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,plannedWorkScope:newVal })
        },
        onDetailedDescriptionChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,detailedDescriptionWork:newVal })
        },
        onContractsChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,contracts:newVal })
        },
        onSAPCostObjectChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,sAPCostObject:newVal })
        },
        onUAPCodeChanged(newVal:any){
            this.$store.commit("projectModule/updateWorkScope",{sequenceId:this.sequenceId,projectId:this.projectId, operationUnitId:this.operationUnitId,uAPCode:newVal })
        },
    }
})
